module.exports = wp.components;


//////////////////
// WEBPACK FOOTER
// external "wp.components"
// module id = 90
// module chunks = 0